import { REQUIRED_CONSENT_GROUPS } from 'client/GrowthEngineering/Dreamdata/DreamdataConfig';

/**
 * Reads the OptanonConsent cookie directly, rather than relying solely on an in-memory flag
 * (window.dreamdataInitialized). This guards against the returning-visitor race where a visitor
 * already granted consent on a previous page load, but this page's async OneTrust callback has
 * not fired yet by the time an event needs to be routed.
 */
function hasDreamdataConsent() {
  try {
    const consentCookie = document.cookie
      .split('; ')
      .find((cookie) => cookie.indexOf('OptanonConsent=') === 0);

    if (!consentCookie) return false;

    const groupsSegment = consentCookie.split('groups=')[1];
    if (!groupsSegment) return false;

    const decodedGroups = decodeURIComponent(groupsSegment.split('&')[0]);

    return REQUIRED_CONSENT_GROUPS.every((group) => decodedGroups.indexOf(`${group}:1`) !== -1);
  } catch (e) {
    return false;
  }
}

export default {
  hasDreamdataConsent,
  REQUIRED_CONSENT_GROUPS,
};
